const angular = require('angular');

const { onTouchendDirectiveDefinition } = require('./on-touchend.directive');

angular.module('oly.common')
    .directive('olyOnTouchend', [onTouchendDirectiveDefinition]);



// WEBPACK FOOTER //
// ./src/olycommon/ontouchend/index.js